import { BUSINESS } from "@/data/businessInfo";

const LOCATION_COORDS = {
  "port-st-lucie": { lat: 27.2730, lng: -80.3582 },
  "fort-pierce": { lat: 27.4467, lng: -80.3256 },
  "vero-beach": { lat: 27.6386, lng: -80.3973 },
  "sebastian": { lat: 27.8164, lng: -80.4706 },
  "stuart": { lat: 27.1975, lng: -80.2531 },
  "jensen-beach": { lat: 27.2544, lng: -80.2295 },
  "palm-city": { lat: 27.1684, lng: -80.2661 },
  "hutchinson-island": { lat: 27.3500, lng: -80.2200 },
  "sewalls-point": { lat: 27.1919, lng: -80.2086 },
  "hobe-sound": { lat: 27.0598, lng: -80.1362 },
  "indiantown": { lat: 27.0275, lng: -80.4856 },
  "tradition": { lat: 27.3900, lng: -80.4700 },
  "west-palm-beach": { lat: 26.7153, lng: -80.0534 },
  "palm-beach-gardens": { lat: 26.8234, lng: -80.1387 },
  "jupiter": { lat: 26.9342, lng: -80.0942 },
  "boynton-beach": { lat: 26.5254, lng: -80.0662 },
  "lake-worth-beach": { lat: 26.6117, lng: -80.0557 },
  "royal-palm-beach": { lat: 26.7084, lng: -80.2306 },
  "wellington": { lat: 26.6587, lng: -80.2684 },
};

// Service area overview map centered on Treasure Coast
export const ServiceAreaMap = ({ className = "" }) => {
  const src = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d450000!2d-80.35!3d27.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d93ca1f7e793a1%3A0x7672f37966c89624!2sSouthern%20Light%20Solutions%20LLC!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus`;
  return (
    <div className={`rounded-2xl overflow-hidden border border-[#6B3A1F]/10 shadow-md ${className}`} data-testid="service-area-map">
      <iframe
        src={src}
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: '300px' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Southern Light Solutions Service Area Map"
      />
    </div>
  );
};

// Location-specific map
export const LocationMap = ({ locationId, locationName, className = "" }) => {
  const coords = LOCATION_COORDS[locationId];
  if (!coords) return null;
  const src = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50000!2d${coords.lng}!3d${coords.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus`;
  return (
    <div className={`rounded-2xl overflow-hidden border border-[#6B3A1F]/10 shadow-md ${className}`} data-testid={`map-${locationId}`}>
      <iframe
        src={src}
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: '250px' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={`Electrician serving ${locationName}, FL`}
      />
    </div>
  );
};
